import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { PageEnConstruction } from './pages/PageEnConstruction';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3f9ygldxpwaxk">
      <div className="flex min-h-screen w-full flex-col bg-creme font-sans" data-id="element-1" data-mp="3fbjar2g4druw">
        <Header data-id="element-2" data-mp="2rkdw2qlx15m6" />
        <div className="flex-1" data-id="element-3" data-mp="2rlyreig20sl3">
          <Routes data-id="element-4" data-mp="2rl6th0yziirn">
            <Route path="/" element={<Home data-id="element-6" data-mp="2mmceka451ect" />} data-id="element-5" data-mp="2riklj086m18w" />
            <Route path="*" element={<PageEnConstruction data-id="element-8" data-mp="2mnnh66lukg2c" />} data-id="element-7" data-mp="2mmvk0rclqa9y" />
          </Routes>
        </div>
        <Footer data-id="element-9" data-mp="31bs27h8dh3oa" />
      </div>
    </BrowserRouter>;
}